/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import {
    Component,
    Inject,
    Input,
} from '@angular/core';

import { IWafProfile, WafMode } from 'generated-types';
import { WafProfileItem } from 'ajs/modules/waf/factories/waf-profile/waf-profile.item.factory';
import { L10nService } from '@vmw/ngx-vip';
import {
    TWafPolicyCollection,
    WafPolicyCollection,
} from 'ajs/modules/waf/factories/waf-policy/waf-policy.collection.factory';

import './waf-profile-custom-preview.component.less';

import * as l10n from './waf-profile-custom-preview.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 * A component for displaying WAF profile custom preview.
 *
 * @author Shanmukha Sarath Kondiparthi
 */
@Component({
    selector: 'waf-profile-custom-preview',
    templateUrl: './waf-profile-custom-preview.component.html',
})
export class WafProfileCustomPreviewComponent {
    /**
     * Waf Profile Item config
     */
    @Input()
    public config: IWafProfile;

    /**
     * Flag for editable to be an item or a message item.
     */
    @Input()
    public readonly isItem: boolean;

    /**
     * Waf Profile Item
     */
    @Input()
    public readonly item: WafProfileItem;

    public readonly l10nKeys = l10nKeys;

    public isWafProfileInEvaluationMode = false;

    private readonly wafPolicyCollection: WafPolicyCollection;

    constructor(
        l10nService: L10nService,
        @Inject(WafPolicyCollection)
        WafPolicyCollection: TWafPolicyCollection,
    ) {
        l10nService.registerSourceBundles(dictionary);
        this.wafPolicyCollection = new WafPolicyCollection();
    }

    public ngOnInit(): void {
        const wafProfileUuid = this.item.config.uuid;

        this.wafPolicyCollection.setParams({
            fields: 'name,waf_profile_ref,mode',
            mode: WafMode.WAF_MODE_EVALUATION,
            'waf_profile_ref.contains': wafProfileUuid,
        });

        // check if waf profile attached to any waf policy in evaluation mode in edit modal.
        if (wafProfileUuid) {
            this.wafPolicyCollection.load().then(() => {
                this.isWafProfileInEvaluationMode = Boolean(this.wafPolicyCollection.items.length);
            });
        }
    }
}
